import styled from "@emotion/styled";
import { theme } from "@product/scmp-sdk";

import { ContentItemPostiesPrimary } from "scmp-app/components/content/content-item-render/variants/posties-primary";
import { Headline as ContentItemPostiesPrimaryHeadline } from "scmp-app/components/content/content-item-render/variants/posties-primary/styles";
import { Headline } from "scmp-app/components/posties/content-homepage/headline";

import Background from "./background.svg";
import Bubble from "./bubble.svg";

export const Wrapper = styled.div``;

export const Container = styled.div`
  position: relative;
  z-index: 1;

  background: #33abbc;

  overflow: hidden;
`;

export const BackgroundContainer = styled.div`
  position: relative;

  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  inline-size: 100%;
  block-size: 100%;
`;

export const ContentContainer = styled.div`
  position: relative;

  display: flex;
  flex-direction: column;
  align-items: center;

  min-block-size: 507px;
  margin-block: 111px 49px;
  padding-block: 0;
  ${theme.breakpoints.up("tablet")} {
    min-block-size: 733px;
    margin-block: 119px 2px;
    padding: 0;
  }
  ${theme.breakpoints.up("desktop")} {
    margin-block: 68px 0;
  }
  ${theme.breakpoints.up("largeDesktop")} {
    margin-block: 0;
  }
`;

export const StyledBackground = styled(Background)`
  position: absolute;
  inset-block-start: 80px;

  block-size: 507px;
  ${theme.breakpoints.up("tablet")} {
    inset-block-start: 90px;

    block-size: 677px;
  }
  ${theme.breakpoints.up("desktop")} {
    inset-block-start: 40px;
  }
`;

export const PigBubbleContainer = styled.div`
  position: relative;
  inset-block-start: -56px;
  z-index: 2;

  display: flex;
  justify-content: center;

  inline-size: 100%;

  ${theme.breakpoints.up("tablet")} {
    inset-block-start: -77px;
  }

  ${theme.breakpoints.up("largeDesktop")} {
    inset-block-start: 165px;

    justify-content: flex-start;

    inline-size: 1440px;
    margin-inline: auto;
  }
`;

export const PigContainer = styled.div`
  position: absolute;

  inline-size: 198px;
  margin-inline-start: 45px;

  ${theme.breakpoints.up("tablet")} {
    inline-size: 248px;
    margin-inline-start: 57px;
  }

  ${theme.breakpoints.up("largeDesktop")} {
    inline-size: 325px;
    margin-inline-start: 68px;
  }
`;

export const StyledPigImage = styled.img`
  inline-size: 100%;
`;

export const BubbleContainer = styled.div`
  position: absolute;

  margin-block-start: 24px;
  margin-inline-end: 124px;

  ${theme.breakpoints.up("tablet")} {
    margin-block-start: 54px;
    margin-inline-end: 154px;
  }

  ${theme.breakpoints.up("largeDesktop")} {
    margin-block-start: -50px;
  }
`;

export const StyledBubble = styled(Bubble)`
  inline-size: 119px;

  ${theme.breakpoints.up("tablet")} {
    inline-size: 149px;
  }

  ${theme.breakpoints.up("largeDesktop")} {
    inline-size: 100%;
  }
`;

export const MiscContainer = styled.div`
  position: absolute;
  inset-block-end: 0;
  inset-inline-end: 0;
  z-index: 1;

  display: none;

  ${theme.breakpoints.up("largeDesktop")} {
    display: block;
  }
`;

export const StyledContentItemPostiesPrimary = styled(ContentItemPostiesPrimary)`
  position: relative;

  ${ContentItemPostiesPrimaryHeadline} {
    color: #ffffff;
  }
`;

export const StyledHeadline = styled(Headline)`
  margin-block-end: 24px;

  ${theme.breakpoints.up("tablet")} {
    margin-block-end: 56px;
  }
`;
